import SmartAppBanner from "./SmartAppBanner";

export default SmartAppBanner;
